module.exports = __webpack_public_path__ + "img/85.33277706.png";